export const GET_STOCKS = "GET_STOCKS";
export const GET_TICKERS = "GET_TICKERS"